// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import ProductForm from '../../../common/ProductForm';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
    paddingTop: theme.spacing(1),
  },
}));

function ProductDetailsPage(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { product, productChanges, onGoBack, onSave } = props;

  return (
    <Box id="ProductDetailsTab-container" className={classes.container}>
      <ProductForm
        product={product}
        productChanges={productChanges}
        onCancel={onGoBack}
        onSave={onSave}
        cancelButtonText={t('common.back')}
        cancelButtonIcon="chevron_left"
        editMode
      />
    </Box>
  );
}

ProductDetailsPage.propTypes = {
  product: PropTypes.object.isRequired,
  onGoBack: PropTypes.func.isRequired,
};

export default ProductDetailsPage;
